import PropTypes from 'prop-types';

import { RateBrowserRatePropType } from './rate-browser-rate';

/** @typedef {import('./rate-browser-rate').RateBrowserRatePropType} RateBrowserRatePropType */

export const RateBrowserSelectedProviderPropType = PropTypes.shape({
  accountNumber: PropTypes.string,
  autoFund: PropTypes.bool,
  isLoading: PropTypes.bool,
  isPrimaryAccount: PropTypes.bool,
  labelProviderId: PropTypes.string,
  name: PropTypes.string,
  rates: PropTypes.arrayOf(RateBrowserRatePropType),
  requiresSetup: PropTypes.bool,
  sellerLabelProviderId: PropTypes.string,
  useHouseCredentials: PropTypes.bool,
});

/**
 * @typedef {object} RateBrowserSelectedProviderPropType
 * @property {string} accountNumber
 * @property {boolean} autoFund
 * @property {boolean} isLoading
 * @property {boolean} isPrimaryAccount
 * @property {string} labelProviderId
 * @property {string} name
 * @property {RateBrowserRatePropType[]} rates
 * @property {boolean} requiresSetup
 * @property {string} sellerLabelProviderId
 * @property {boolean} useHouseCredentials
 */
